export class Semaphore {
    count = 0;
    waiters: (() => void)[] = [];

    acquire() {
        this.count++;
    }

    release() {
        this.count--;
        if (this.count <= 0) {
            // resolve all waiters now that count is 0
            this.waiters.forEach((resolve) => resolve());
            this.waiters = [];
            this.count = 0;
        }
    }

    async wait() {
        if (this.count <= 0) return;
        return new Promise<void>((resolve) => {
            // resolve will run on release, when count goes to 0
            this.waiters.push(resolve);
        });
    }
}
